<script setup>
import { computed, defineAsyncComponent } from 'vue';

const props = defineProps({
    name: {
        type: String,
        required: true,
    },
    parameters: {
        type: Object,
        required: false,
        default: () => ({}),
    },
});

const component = computed(() => defineAsyncComponent({
    loader: () => import(`./Statamic/${props.name}.vue`),
    loadingComponent: 'div',
    delay: 0,
}));
</script>

<template>
    <component
        :is="component"
        v-bind="parameters"
    />
</template>
